module.exports = __webpack_public_path__ + "img/template_5.f38a7387.png";